import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import AvinorLogo from "./AvinorLogo";
const AvinorLogoLink = ({ to }) => {
    return (_jsx(Link, { to: to, style: { padding: "0 1rem", height: "1.5rem", display: "flex", alignItems: "center" }, children: _jsx(AvinorLogo, {}) }));
};
export default AvinorLogoLink;
